import React, { useState, useRef, useEffect } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useGlobalContext } from '../../../Context/GlobalContext';
import Cookies from 'js-cookie';

const PayrollAdvanceAction = ({ toggleOffCanvasAction, payrollFun, setIsOffCanvasOpenAction, item, staff, isOffCanvasOpenAction, setPaidPayment }) => {
    const { baseUrl, openToast } = useGlobalContext();
    const [amount, setAmount] = useState(item?.amount ?? "");
    const [note, setNote] = useState(item?.note ?? "");
    const [date, setDate] = useState(item?.date ?? "");
    const [isLoading, setIsLoading] = useState(false)
    const sidebarRef = useRef(null);


    async function savePayment() {
        try {
            const response = await fetch(baseUrl + "payment", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
                },
                body: JSON.stringify({
                    data: [{
                        amount: Number(amount),
                        note: note,
                        date: new Date(date),
                        staffId: item?.staffDetails?.id,
                        status: "SAVED",
                        type: "ADVANCE",
                        salaryDetailsId: item?.staffDetails?.SalaryDetails[0]?.id
                    }]
                })
            })
            if (response.status === 201) {
                const data = await response.json();
                openToast("Payment Updated Successfully", "success");
                // Update the PaymentHistory array
                setIsOffCanvasOpenAction(); // Close the off-canvas
                payrollFun();

            } else {
                openToast("An Error Occurred", "error");
            }

        }
        catch (error) {
            openToast("An Error Occured", "error")
        }
    }


    useEffect(() => {
        function handleClickOutside(event) {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setIsOffCanvasOpenAction(); // Close sidebar if clicked outside
            }
        }

        if (isOffCanvasOpenAction) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOffCanvasOpenAction, setIsOffCanvasOpenAction]);


    useEffect(() => {
        if (item) {
            setAmount(item?.amount || 0); // Default to 0 if amount is undefined
            setNote(item?.note || ""); // Default to an empty string if note is undefined
            if (item?.date) {
                const validDate = new Date(item.date);
                if (!isNaN(validDate)) {
                    setDate(validDate.toISOString().split("T")[0]);
                } else {
                    console.error("Invalid date format:", item.date);
                    setDate(""); // Default to an empty string for invalid dates
                }
            } else {
                setDate(""); // Default to an empty string if date is undefined
            }
        }
    }, [item]);
    return (
        <div
        ref={sidebarRef}
        className={`fixed top-[56px] right-0 h-screen sm:w-[400px] w-full z-[99] shadow-cs bg-white payroll-sidebar shadow-lg transform transition-transform duration-300 ${
            isOffCanvasOpenAction ? "translate-x-0" : "translate-x-full"
        }`}
        >
            <div className="relative w-full h-full">
                <div className="flex justify-between items-center border-gray-200 p-4 border-b">
                    <h2 className="font-semibold text-[#000] text-[18px]">{item?.name}</h2>
                    <button
                        className="text-[black]"
                        onClick={setIsOffCanvasOpenAction}
                    >
                        <CloseIcon />
                    </button>
                </div>
                <div className="relative z-[1] bg-red mb-[10px] p-[10px] pb-[20px] w-full max-w-md h-[82%] overflow-y-scroll">
                    <div className="flex justify-between items-center bg-[#e5e7eb3b] mb-[10px] p-[10px] w-full">
                        <p className="font-normal text-muted-foreground text-sm">Add Advance</p>
                    </div>
                    <div className='flex justify-between items-center gap-[10px] pt-[14px]'>
                        <label className='font-light text-[14px]'>Amount</label>
                        <div className='relative'>
                            <input type="text" value={amount} onChange={(e) => setAmount(e.target.value)} className='focus:shadow-cs px-[10px] py-[5px] pl-[20px] border rounded-[10px] w-[232px] focus-visible:outline-none' />
                            <span className='top-[6px] left-[10px] absolute'>₹</span>
                        </div>
                    </div>
                    <div className='flex justify-between items-center gap-[10px] pt-[14px]'>
                        <label className='font-light text-[14px] whitespace-nowrap'>Payment Date</label>
                        <div className=''>
                            <input type="date" value={(date)} onChange={(e) => setDate(e.target.value)} className='focus:shadow-cs px-[10px] py-[5px] pl-[20px] border rounded-[10px] w-[232px] font-light focus-visible:outline-none' />
                        </div>
                    </div>
                    <div className='flex justify-between items-center gap-[10px] pt-[14px]'>
                        <label className='font-light text-[14px]'>Notes</label>
                        <div className=''>
                            <textarea value={note} onChange={(e) => setNote(e.target.value)} className='focus:shadow-cs px-[10px] py-[5px] pl-[20px] border rounded-[10px] w-[232px] font-light focus-visible:outline-none' />
                        </div>
                    </div>
                    <div className='bottom-[40px] sm:bottom-[20px] left-0 absolute w-full'>
                        <div className='bottom-[40px] sm:bottom-[20px] left-0 absolute w-full'>
                            <div className='flex justify-between px-[20px]'>
                                <button onClick={setIsOffCanvasOpenAction} className='w-[48%] first-btn'>Cancel</button>
                                <button className={`justify-center w-[48%] second-btn ${isLoading && isLoading == true ? "opacity-50 cursor-not-allowed" : "opacity-100"}`} onClick={savePayment}>Save Payment</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PayrollAdvanceAction